<template lang="html">

  <div class="cover-popup row-center">
    <div class="popup">

      <p><strong>{{$t('popup_pedir_naf.titulo')}}</strong></p>

      <p>{{$t('popup_pedir_naf.subtitulo')}}</p>

      <p style="margin-left: 20px;">{{$t('popup_pedir_naf.parrafo1')}}</p>

      <p style="margin-left: 20px;">{{$t('popup_pedir_naf.parrafo2')}}</p>

      <p></p>

      <p>{{$t('popup_pedir_naf.pie')}}</p>

      <div class="contenedor-botones">
        
        <button class="btn -skull-primary" @click="irACV">{{$t('popup_pedir_naf.ir')}}</button>

      </div>

    </div>
  </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex';
    import router from '@/router'
  
    export default  {
      name: 'popup-pedir-NAF',
      data(){
        return {
        }
      },
      computed : {
        ...mapGetters({
          brand:'getBrand',
          style : 'getStyles'
        })
      },
      methods : {
        ...mapActions(['erasePedirNAF']),
        irACV(){
          this.erasePedirNAF();
          this.$router.push('/cv');
        }
      }
    }
  </script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-pedir-NAF.vue